import BookingDetail from './BookingDetail';

export default BookingDetail;
